import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import FieldSet from 'flarum/common/components/FieldSet';
import Switch from 'flarum/common/components/Switch';
import Link from 'flarum/common/components/Link';
async function updatePolicy(policy, value) {
  const endpoint = "".concat(app.forum.attribute('apiUrl'), "/fof-terms-policies/").concat(policy.id()).concat(value ? '/accept' : '/decline');
  const updated = await app.request({
    url: endpoint,
    method: 'POST'
  });
  app.store.pushPayload(updated);
}
export default function () {
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    var _app$session$user;
    const optionalPolicies = app.store.all('fof-terms-policies').filter(policy => policy.optional());
    if (!optionalPolicies.length) {
      return;
    }
    const policyState = (_app$session$user = app.session.user) == null ? void 0 : _app$session$user.fofTermsPoliciesState();
    if (!policyState) {
      return;
    }
    items.add('policies', m(FieldSet, {
      label: app.translator.trans('fof-terms.forum.user_settings.optional_policies_label')
    }, optionalPolicies.map(policy => {
      const policyId = policy.id();
      const state = policyId && policyState ? policyState[policyId] : undefined;
      const is_accepted = (state == null ? void 0 : state.is_accepted) || false;
      return m("div", {
        className: "Fof-Terms-Policy-User-Settings-Management"
      }, m(Switch, {
        state: is_accepted,
        onchange: async value => {
          const policyId = policy.id();
          if (policyId && policyState) {
            policyState[policyId].is_accepted = value;
          }
          this[policy.form_key()] = value;
          await updatePolicy(policy, value);
          m.redraw();
        }
      }, ' ', policy.url() ? m(Link, {
        target: "_blank",
        href: policy.url()
      }, policy.name()) : policy.name()));
    })), -99);
  });
}